import React from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  CloseButton,
  Gradient,
  MedalImg,
  MedalWrapper,
  ModalContainer,
  ModalContent,
  ModalText,
  ModalTitle,
  Shimmer,
  TextContainer,
  TrophyImg,
  TrophyWrapper,
} from "./CreatorsRewardModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

import FirstMedal from "../../assets/images/1Medal.webp";
import SecondThirdMedal from "../../assets/images/23Medal.webp";
import GoldMedal from "../../assets/images/goldMedal.webp";
import SilverMedal from "../../assets/images/silverMedal.webp";
import Trophy from "../../assets/images/trophy.webp";

const CreatorsRewardModal = ({ isOpen, onClose }) => {
  useLockBodyScroll(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3600 }}
    >
      <ModalContainer>
        <Gradient />
        <ModalContent>
          <CloseButton onClick={onClose}>
            <CloseSvg />
          </CloseButton>
          <TrophyWrapper>
            <TrophyImg src={Trophy} alt="Playbun - Trophy" />
          </TrophyWrapper>
          <ModalTitle>Creator Rewards</ModalTitle>

          <TextContainer>
            <MedalWrapper>
              <MedalImg src={FirstMedal} alt="Playbun - First Medal" />
              <Shimmer $src={FirstMedal} />
            </MedalWrapper>
            <ModalText>
              <ModalText $bold>The #1 creator</ModalText> gets a{" "}
              <ModalText $bold> $1,000</ModalText> bonus every month.
            </ModalText>
          </TextContainer>

          <TextContainer>
            <MedalWrapper>
              <MedalImg
                src={SecondThirdMedal}
                alt="Playbun - Second and Third Medal"
              />
              <Shimmer $src={SecondThirdMedal} />
            </MedalWrapper>
            <ModalText>
              <ModalText $bold>The #2 and #3 creators </ModalText> get a{" "}
              <ModalText $bold> $500</ModalText> bonus every month.
            </ModalText>
          </TextContainer>

          <TextContainer>
            <MedalWrapper>
              <MedalImg src={GoldMedal} alt="Playbun - Gold Medal" />
              <Shimmer $src={GoldMedal} />
            </MedalWrapper>
            <ModalText>
              <ModalText $bold>Top 5 creators</ModalText> get increased
              earnings.
              <br />
              4-3-3-2-2-1 credits by month.
            </ModalText>
          </TextContainer>

          <TextContainer>
            <MedalWrapper>
              <MedalImg src={SilverMedal} alt="Playbun - Silver Medal" />
              <Shimmer $src={SilverMedal} />
            </MedalWrapper>
            <ModalText>
              <ModalText $bold>Top 10 creators</ModalText> get increased
              earnings.
              <br />
              3-3-3-2-2-1 credits by month.
            </ModalText>
          </TextContainer>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CreatorsRewardModal;
